interface FileNameParts {
  reporteBase: string;
  identificador: string;
  denominacion: string;
  fecha: Date;
  extension: string;
}

export const generateReportFileName = ({
                                         reporteBase,
                                         identificador,
                                         denominacion,
                                         fecha,
                                         extension,
                                       }: FileNameParts): string => {
  const anio = fecha.getFullYear();
  const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
  const periodo = `${anio}${mes}`;

  const cleanDenominacion = denominacion.replace(/ /g, '_');

  return `${reporteBase}_${identificador}_${cleanDenominacion}_${periodo}.${extension.toLowerCase()}`;
};